import { subject } from '@casl/ability';
import { isUndefined } from './isDefined';

export default function createSubject(element, obj) {
  if (isUndefined(obj)) {
    return subject(element);
  }
  return subject(element, obj);
}
